export const robotoFont = "Roboto, sans-serif";
export const powerGroteskFont = "'Power Grotesk', sans-serif";
export const powerGroteskLightFont = "'Power Grotesk Light', sans-serif";
export const spaceGroteskFont = "'Space Grotesk', sans-serif";

export const headingTypography = {
  h1: {
    fontFamily: powerGroteskFont,
    fontWeight: 500,
    fontSize: '1.875rem', // 30px similar to Notion/Obsidian h1
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: powerGroteskFont,
    fontWeight: 500,
    fontSize: '1.5rem', // 24px
    lineHeight: 1.3,
  },
  h3: {
    fontFamily: powerGroteskFont,
    fontWeight: 500,
    fontSize: '1.25rem', // 20px
    lineHeight: 1.4,
  },
  h4: {
    fontFamily: powerGroteskFont,
    fontWeight: 500,
    fontSize: '1rem', // 16px
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: powerGroteskFont,
    fontWeight: 500,
    fontSize: '0.875rem', // 14px
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: powerGroteskFont,
    fontWeight: 500,
    fontSize: '0.75rem', // 12px
    lineHeight: 1.4,
  },
};

export default headingTypography;
export const monospaceFont = 'Consolas, Monaco, "Courier New", monospace';
